console.log('Ready javascript');

// Mobile > all touchstar DOM perfect Iphone
// document.addEventListener("touchstart", function(){}, true);

$('#js-c-section-btn-mobile').click(function(){
 $(this).toggleClass('is-active');
 $('html').toggleClass('is-active-menu-mobile');
});

// console.log( window.innerWidth );
// const mq = window.matchMedia( "(min-width: 900px)" );
// var itemEscola  = document.querySelector('.item--escola a');
// var itemOfertaEducativa  = document.querySelector('.item--oferta-educativa a');
// if (mq.matches) {
//        console.log("window width >= 900px");
// } else {
//      console.log("window width < 900px");
//      itemEscola.href = "#";
//      itemOfertaEducativa.href = "#";
// }


$( window).scroll(function() {
  if ($(window).scrollTop()> 250 ) {
    $('#header').addClass('is-active');
  } else if($(window).scrollTop()< 100 ) {
    $('#header').removeClass('is-active');
  }
});


$('.js-c-slider-home').slick(
{
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows:true,
});
$('.js-slider').slick(
{
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows:false,
  fade: true
});

$('.js-slider__c-carousel-logos').slick({
  infinite: true,
  slidesToShow: 7, 
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  // centerMode: true, 
  // variableWidth: false,
  responsive: [
    {
      breakpoint: 800, 
      settings: {
        slidesToShow: 5,
      }
    },
    {
      breakpoint: 600, 
      settings: {
        slidesToShow: 3,
      }
    }
  ]
});

$('.c-carousel').slick({
  infinite: true,
  slidesToShow: 4, 
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  // dots: true,

  centerMode: true, 
  variableWidth: false,

  responsive: [
    {
      breakpoint: 800, 
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600, 
      settings: {
        slidesToShow: 2,
      }
    }
  ]
});

$(".c-documents .item-title").click(function(){
  $(this).toggleClass("c-documents__title-active");
  $(this).parents("div").toggleClass("c-documents__element-active");
});





/*
  
    https://tympanus.net/Tutorials/CustomFileInputs/

    By Osvaldas Valutis, www.osvaldas.info
    Available for use under the MIT License
  */

  ;( function ( document, window, index )
  {
    var inputs = document.querySelectorAll( '.inputfile' );
    Array.prototype.forEach.call( inputs, function( input )
    {
      var label  = input.nextElementSibling,
      labelVal = label.innerHTML;

      input.addEventListener( 'change', function( e )
      {
        var fileName = '';
        if( this.files && this.files.length > 1 )
          fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
        else
          fileName = e.target.value.split( '\\' ).pop();

        if( fileName )
          label.querySelector( 'span' ).innerHTML = fileName;
        else
          label.innerHTML = labelVal;
      });

    // Firefox bug fix
    input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
    input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
  });
  }( document, window, 0 ));






